export default {
    approvalStatus: {
        pending: 0,
        approved: 1,
        rejected: 2,
    },
    testingStatus: {
        pending: 0,
        approved: 1,
        rejected: 2,
    },
}
